import React from "react";
import { css } from "@emotion/react";

import ActionBox from "../components/actionBox";
import { colors } from "../assets/styles/variables";
import iconPurchase from "../assets/icons/icon_purchase.svg";
import logoAmazon from "../assets/images/logo_amazon.png";

const purchase = css`
  background-color: ${colors.gray};

  .link {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 120px;
    width: 100%;
    height: 40px;
    margin: 0 auto;
    padding: 0 20px;
    border: none;
    border-radius: 20px;
    background-color: ${colors.white};
  }
`;

interface Props {
  amznUrl: string;
}

const Purchase = (props: Props) => {
  const { amznUrl } = props;

  return (
    <ActionBox
      title="購入する"
      icon={iconPurchase}
      iconWidth={26}
      iconHeight={24}
    >
      <div css={purchase}>
        <a
          className="link"
          href={amznUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={logoAmazon} width={74} height={22} alt="amazon" />
        </a>
      </div>
    </ActionBox>
  );
};

export default Purchase;
